if (document.querySelector('.multicolumn.testimonials_wrap .multicolumn-list')) {
  var elem = document.querySelector('.multicolumn.testimonials_wrap .multicolumn-list');
  var flkty = new Flickity(elem, {
    cellAlign: 'left',
    autoPlay: true,
    contain: true,
    prevNextButtons: false,
    groupCells: 3,
    pageDots: true,
    wrapAround: true
  });
}

if (document.querySelector('slider-component.thumbnail-slider ul.thumbnail-list')) {
  
  var elem2 = document.querySelector('slider-component.thumbnail-slider ul.thumbnail-list');
  var flkty2 = new Flickity(elem2, {
    draggable: false,
    cellAlign: 'left',
    contain: true,
    groupCells: 3,
    prevNextButtons: true,
    wrapAround: true,
    pageDots: false
  });
  
  document.querySelectorAll('.product .product__info-container variant-selects label').forEach(label => {
    label.addEventListener('click', function() {
        setTimeout(() => {
          flkty2.resize();
          flkty2.resize();
          flkty2.resize();
        }, 1000);
    });
  });
  
}


  let flkty4;
  function initializeFlickity() {
      if (!flkty4) {
          flkty4 = new Flickity('.collection-list-wrapper.shop_by_category .collection-list', {
              cellAlign: 'left',
              contain: true
          });
      }
  }
  function destroyFlickity() {
      if (flkty4) {
          flkty4.destroy();
          flkty4 = null;
      }
  }
  function checkDeviceWidth() {
      const mobileWidth = 490;
      if (window.innerWidth <= mobileWidth) {
          initializeFlickity();
      } else {
          destroyFlickity();
      }
  }
  checkDeviceWidth();
  window.addEventListener('resize', checkDeviceWidth);